__turbopack_context__.v({
  "popover": "Popover-module-scss-module__g3JG-W__popover",
  "popoverFadeIn": "Popover-module-scss-module__g3JG-W__popoverFadeIn",
  "popover__arrow": "Popover-module-scss-module__g3JG-W__popover__arrow",
  "popover__content": "Popover-module-scss-module__g3JG-W__popover__content",
  "popover__inner": "Popover-module-scss-module__g3JG-W__popover__inner",
  "popover__title": "Popover-module-scss-module__g3JG-W__popover__title",
  "triggerInline": "Popover-module-scss-module__g3JG-W__triggerInline",
});
